<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-position="top">
    <el-form-item label="物流公司" prop="Courier">
      <metaPicker :current.sync="formdata.Courier" typeId="courier" />
    </el-form-item>
    <el-form-item label="发货单号" prop="Code">
      <el-input v-model="formdata.Code" placeholder="如不填系统将自动创建." />
    </el-form-item>
    <el-form-item label="备注" prop="Message">
      <el-input v-model="formdata.Message" />
    </el-form-item>
    <el-form-item>
      <uploader ref="uploadRef" :data="{ ObjectId: formdata.Id, Mode: 'parcel-copy' }" multiple :auto-upload="false" accept=".jpg,.png">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">选取文件上传</el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="onSubmit">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/picker.vue"),
    uploader: () => import("@/views/system/file/multipleUpload.vue")
  },
  props: {
    _form: { type: Object },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      formdata: { ...this._form }
    }
  },
  methods: {
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.mall.parcel.confirm(this.formdata).then(() => {
            return this.$refs.uploadRef.onSubmit()
          }).then(() => {
            this.callback()
            this.$layer.close(this.layerid)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style>
</style>